import { useContext } from 'react'
import { PriceLabelUnseenCountContext } from 'context/priceLabelUnseenCountContext'

const usePriceLabelUnseenCount = () => {
  const context = useContext(PriceLabelUnseenCountContext)

  if (context === undefined) {
    throw new Error(
      'usePriceLabelUnseenCount must be used within a PriceLabelUnseenCountProvider',
    )
  }

  return context
}

export default usePriceLabelUnseenCount
